import * as Popover from "@radix-ui/react-popover";
import { CircleHelp, X } from "lucide-react";
import { useDesktopInformation } from "./desktopInformation";
import "./tableScopeInfo.css";

export default function TableScopeInfo({ title, text, language }: {title:string;text:string;language:string}) {
  const desktop=useDesktopInformation();
  if(!desktop)return null;
  const copy=({tr:{info:"Bilgi",close:"Kapat"},en:{info:"Information",close:"Close"},ru:{info:"Информация",close:"Закрыть"},uz:{info:"Ma’lumot",close:"Yopish"}} as const)[language as "tr"|"en"|"ru"|"uz"]??{info:"Bilgi",close:"Kapat"};
  const label=`${title} · ${copy.info}`;
  return <Popover.Root>
    <Popover.Trigger asChild><button type="button" className="table-scope-info-trigger" aria-label={label} title={label}><CircleHelp size={16} aria-hidden="true" /></button></Popover.Trigger>
    <Popover.Portal><Popover.Content className="table-scope-info-panel" role="dialog" aria-label={label} sideOffset={7} align="start" collisionPadding={12}>
      <p>{text}</p><Popover.Close asChild><button type="button" aria-label={copy.close}><X size={15} aria-hidden="true" /></button></Popover.Close>
    </Popover.Content></Popover.Portal>
  </Popover.Root>;
}
